import React, { ReactElement } from 'react';
import { DetailInfo, SectionInfo } from '../Activite/Sections';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { AjusterSautsDeLigne } from './ActivitePDF';

export function Detail(props: DetailInfo): ReactElement | null {
    const { optionnel, texte, tooltip, icone, titre, long, hide } = props;
    const styles = StyleSheet.create({
        container: {
            flexDirection: 'column',
        },
        wrapper: {
            flexDirection: long ? undefined : 'row',
            marginBottom: 6,
            flexWrap: 'wrap',
        },
        titre: {
            flexShrink: 0, // Ensure titre does not shrink.
            fontWeight: 700,
        },
        texte: {
            flexShrink: 1, // Allow texte to shrink if necessary.
        },
    });
    return !optionnel || texte ? (
        hide ? null : (
            <View style={styles.wrapper}>
                <Text style={styles.titre}>{titre ? `${titre} : ` : ''}</Text>
                <Text style={styles.texte}>{texte}</Text>
            </View>
        )
    ) : null;
}

export function Separateur(): ReactElement {
    return <View style={{ marginVertical: 20, borderBottom: 1, borderColor: '#E6E6E6' }} />;
}

export function Section(props: SectionInfo): ReactElement | null {
    const { titre, texte, champs, noHr, hide, accordeon } = props;
    const styles = StyleSheet.create({
        titre: {
            fontSize: 15,
            marginBottom: 12,
            fontWeight: 500,
        },
    });
    return hide ? null : (
        <View>
            {!noHr && <Separateur />}
            <Text style={styles.titre}>{titre}</Text>
            <Text>{!accordeon && texte}</Text>
            {champs?.map((champ, index) => (
                <Detail key={index} {...champ} />
            ))}
        </View>
    );
}
